// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-button[data-v-731dc4fa]{display:block;min-width:265px;text-align:left;border-bottom:1px solid #f2f2ff;padding-bottom:9px;margin-bottom:8px}.action-button img[data-v-731dc4fa]{width:18px;margin-right:9px}.action-button span[data-v-731dc4fa]{color:#200033;font-size:16px}.action-button[data-v-731dc4fa]:last-child{margin-bottom:0;border-bottom:none;padding-bottom:0}", ""]);
// Exports
module.exports = exports;
